// extracted by mini-css-extract-plugin
export var closeButton = "_l2-2";
export var closeButtonIcon = "_l2-3";
export var lightboxContent = "_l2-1";
export var lightboxOverlay = "_l2-0";